// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 428 ? "00f2183e" : chunkId) + "." + {"428":"1ae110bf25d2cd5c","714":"11e7f7089aeebb4d"}[chunkId] + ".js";
};